/**
 * Raids on home (v1 ticket 47), one quiet line in the bottom panel above Record and Type: an army waiting
 * ("*Neda*'s army is at your gates: 5 weapons." **Defend**), else an unread report with **Read**. Home reads
 * `GET /api/raids` (beta only) and hands it in; with nothing waiting, or no read, there is no line.
 */
import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from '../../i18n';
import { tParts } from '../../bidi-html';
import { go } from '../../router';
import type { RaidOverview } from './raid-api';
import { homeLine } from './raid-army';

@customElement('raid-gate')
export class RaidGate extends LitElement {
  @property({ attribute: false }) overview?: RaidOverview;

  protected createRenderRoot() { return this; }

  render() {
    const line = homeLine(this.overview);
    if (!line) return nothing;
    if (line.kind === 'spoils') {
      return html`<div class="raid-gate" data-kind="spoils" role="status">
        <span class="raid-gate-line">${line.n === 1 ? t('raid.home.spoilsOne') : t('raid.home.spoils', { n: line.n })}</span>
        <button class="btn primary raid-gate-go" @click=${() => go('/raid/spoils')}>${t('raid.spoils.go')}</button>
      </div>`;
    }
    const name = { name: html`<em><bdi dir="auto">${line.name}</bdi></em>` };
    // Incoming defence is always direct. Optional help from the defence screen carries this raid's exact URL.
    const open = () => go(`/raid/${encodeURIComponent(line.id)}`);
    return html`<div class="raid-gate" data-kind=${line.kind} role="status">
      <span class="raid-gate-line">
        ${line.kind === 'army'
          ? line.weapons === 1 ? tParts('raid.home.armyOne', name) : tParts('raid.home.army', name, { n: line.weapons })
          : tParts(line.side === 'attacker' ? 'raid.home.reportOn' : 'raid.home.reportFrom', name)}
      </span>
      <button class="btn primary raid-gate-go" @click=${open}>${t(line.kind === 'army' ? 'raid.defend' : 'raid.read')}</button>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'raid-gate': RaidGate }
}
